import {
  Box,
  Checkbox,
  Fade,
  List,
  ListItem,
  makeStyles,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ModalConfirm from 'src/app/components/ModalConfirm';
import { DEVICE_STATUS, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { MESSAGE } from 'src/app/constant/message';
import { closeDialogConfirm, showDialogConfirm } from 'src/features/uiSlice';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import DialogConfirm from 'src/app/components/DialogConfirm';
import LoadingComponent from 'src/app/components/Loading';
import {
  controlSoundWarning,
  deleteDevices,
  postExtendDevice,
  recallDevices,
  recallDevicesByAgency,
  updateDeviceDisplayName,
} from 'src/features/deviceSlice';
import ActiveDevice from './ActiveDevice';
import EditDevice from './EditDevice';
import './style.css';
import TransferDevice from './TransferDevice';
import EditVersion from './EditVersion';
import ExtendDevice from './ExtendDevice';
import TransferSeller from './TransferSeller';
import AddDisplayName from './AddDisplayName';
import ChangeLicensePlate from './ChangeLicensePlate';
import { buttonPermissions, menuPermissions } from './constance';
import { getDetailVehicle } from 'src/features/vehicleSlice';
import { getRemainingDays, getTransmissionStatusText } from 'src/app/utils/commomService';
import ExtendService from './ExtendService';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const truncateText = (text, maxLength = 30) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

const DEVICE_TABLE_HEAD_CELLS = [
  {
    id: 'index',
    label: 'STT',
    style: { width: 50, minWidth: 50, textAlign: 'center' },
    sortable: false
  },
  {
    id: 'license_plate',
    label: 'Biển số',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'name',
    label: 'Tên gợi nhớ',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'vehicle_type',
    label: 'Loại phương tiện',
    style: { width: 130, minWidth: 130 },
    sortable: false
  },
  {
    id: 'battery',
    label: 'Điện áp',
    style: { width: 100, minWidth: 100 }
  },
  {
    id: 'slots_or_tonnage',
    label: 'Số chỗ/Tải trọng',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'status_transmission',
    label: 'Tích truyền',
    style: { width: 120, minWidth: 120, textAlign: 'center' }
  },
  {
    id: 'device_type',
    label: 'Loại thiết bị',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'serial',
    label: 'Serial',
    style: { width: 150, minWidth: 150 },
    sortable: false
  },
  {
    id: 'imei',
    label: 'Imei sim',
    style: { width: 100, minWidth: 180 },
    sortable: false
  },
  {
    id: 'hardware_version',
    label: 'Phiên bản HW',
    style: { width: 130, minWidth: 130 }
  },
  {
    id: 'firmware_version',
    label: 'Phiên bản FW',
    style: { width: 130, minWidth: 130 }
  },
  {
    id: 'status',
    label: 'Trạng thái',
    style: { width: 100, minWidth: 100 }
  },
  {
    id: 'active_at',
    label: 'Ngày kích hoạt',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'service_package',
    label: 'Dịch vụ',
    style: { width: 150, minWidth: 150 }
  },
  {
    id: 'remaining_days',
    label: 'Số ngày còn lại',
    style: { width: 140, minWidth: 140 }
  },
  {
    id: 'extend_package',
    label: 'Gói dịch vụ gia hạn',
    style: { width: 160, minWidth: 160 }
  },
  {
    id: 'date_of_manufacture',
    label: 'Ngày sản xuất',
    style: { width: 140, minWidth: 140 }
  },
  {
    id: 'end_user_name',
    label: 'Người dùng',
    style: { width: 150, minWidth: 150 },
    sortable: false
  },
  {
    id: 'end_user_phone',
    label: 'Số điện thoại',
    style: { width: 120, minWidth: 120 },
    sortable: false
  },
  {
    id: 'agency_name',
    label: 'Đại lý',
    style: { width: 150, minWidth: 150 },
    sortable: false
  }
];

const getDeviceStatusRank = device => {
  if (device?.status === DEVICE_STATUS.ACTIVE) {
    return device?.deviceServicePackages?.remaining_days > 0 ? 2 : 1;
  }

  if (device?.status === DEVICE_STATUS.INACTIVE) {
    return 0;
  }

  return -1;
};

const getRemainingDaysSortValue = endDate => {
  if (!endDate) return -1;

  const now = moment();
  const expiration = moment(endDate);
  if (!expiration.isValid()) return -1;

  return expiration.diff(now, 'seconds');
};

const getSlotsOrTonnageSortValue = device => {
  const vehicleType = device?.vehicle?.vehicle_type?.title;

  if (vehicleType === 'Xe khách') {
    return Number(device?.vehicle?.vehicle_type?.slots) || 0;
  }

  if (vehicleType === 'Xe tải') {
    return Number(device?.vehicle?.vehicle_type?.tonnage) || 0;
  }

  return 0;
};

const getDeviceSortValue = (device, field) => {
  switch (field) {
    case 'license_plate':
      return device?.vehicle?.license_plate || '';
    case 'name':
      return device?.name || '';
    case 'vehicle_type':
      return device?.vehicle?.vehicle_type?.title || '';
    case 'battery':
      return device?.battery || 0;
    case 'slots_or_tonnage':
      return getSlotsOrTonnageSortValue(device);
    case 'status_transmission':
      return Number(device?.status_transmission ?? 0);
    case 'device_type':
      return device?.deviceType?.name || '';
    case 'serial':
      return device?.serial || '';
    case 'imei':
      return device?.imei || '';
    case 'hardware_version':
      return device?.hardware_version || '';
    case 'firmware_version':
      return device?.firmware_version || '';
    case 'status':
      return getDeviceStatusRank(device);
    case 'active_at':
      return device?.active_at ? moment(device.active_at).valueOf() : 0;
    case 'service_package':
      return device?.deviceServicePackages?.servicePackage?.name || '';
    case 'remaining_days':
      return getRemainingDaysSortValue(device?.subscription?.end);
    case 'extend_package':
      return device?.servicePackageExtend?.[0]?.servicePackage?.name || '';
    case 'date_of_manufacture':
      return device?.date_of_manufacture
        ? moment(device.date_of_manufacture).valueOf()
        : 0;
    case 'end_user_name':
      return device?.end_user?.user?.full_name || '';
    case 'end_user_phone':
      return device?.end_user?.user?.phone || '';
    case 'agency_name':
      return `${device?.agency?.name || ''} ${device?.agency?.agency_code || ''}`.trim();
    default:
      return '';
  }
};

const compareSortValues = (leftValue, rightValue) => {
  const isLeftNumber = typeof leftValue === 'number';
  const isRightNumber = typeof rightValue === 'number';

  if (isLeftNumber && isRightNumber) {
    if (leftValue < rightValue) return -1;
    if (leftValue > rightValue) return 1;
    return 0;
  }

  return String(leftValue).localeCompare(String(rightValue), 'vi', {
    numeric: true,
    sensitivity: 'base'
  });
};

const RenderListExtendPackages = ({ listPackages, classes }) => {
  const [anchorElRow, setAnchorElRow] = useState(null);

  const handlePopoverOpen = event => {
    setAnchorElRow(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorElRow(null);
  };

  const open = Boolean(anchorElRow);
  return (
    <div>
      <Typography
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        style={{ fontSize: '14px' }}
      >
        {listPackages[0]?.servicePackage?.name || '--'}
      </Typography>
      {listPackages?.length > 0 && (
        <Popover
          id="mouse-over-popover"
          className={classes.popover}
          classes={{
            paper: classes.paper
          }}
          open={open}
          anchorEl={anchorElRow}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left'
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          {listPackages?.map((item, index) => {
            return (
              <Typography
                key={index}
                style={{ fontSize: '14px', lineHeight: '2' }}
              >
                {item?.servicePackage?.name}
              </Typography>
            );
          })}
        </Popover>
      )}
    </div>
  );
};

const Results = ({
  isLoading,
  getListDeviceRef,
  totalDevice,
  listDevice,
  currentParams
}) => {
  const query = useQuery();
  const dispatch = useDispatch();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('status_transmission');
  const [rowsSelected, setRowsSelected] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openEditVersionModal, setOpenEditVersionModal] = useState(false);
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openRecallModal, setOpenRecallModal] = useState(false);
  const [openExtendModal, setOpenExtendModal] = useState(false);
  const [openModalActive, setOpenModalActive] = useState(false);
  const [openModalSeller, setOpenModalSeller] = useState(false);
  const [openModalSettingSound, setOpenModalSettingSound] = useState(false);
  const [openDisplayNameModal, setOpenDisplayNameModal] = useState(false);
  const [openSwapLicensePlateModal, setOpenSwapLicensePlateModal] = useState(
    false
  );
  const [
    openChangeLicensePlateModal,
    setOpenChangeLicensePlateModal
  ] = useState(false);
  const [openExtendServiceModal, setOpenExtendServiceModal] = useState(false);

  const [itemCurrent, setItemCurrent] = useState({});
  const [dataChecked, setDataChecked] = useState({});
  const [editOnBar, setEditOnBar] = useState(true);

  // Menu action right

  const ACTION_LABELS = {
    ACTIVATE: 'Kích hoạt thiết bị',
    SELECT_PACKAGE: 'Chọn gói dịch vụ gia hạn',
    EDIT_DEVICE: 'Cấu hình thiết bị',
    TRANSFER_AGENT: 'Chuyển xuống đại lý',
    EXTEND: 'Gia hạn thiết bị',
    RECALL: 'Thu hồi thiết bị bảo hành',
    SELECT_SELLER: 'Chọn người bán',
    ADD_DISPLAY_NAME: 'Thêm tên gợi nhớ',
    SWAP_LICENSE_PLATE: 'Dùng tên/biển số',
    CONTROL_ALERT: 'Cài đặt âm thanh cảnh báo',
    DELETE: 'Xóa',
    CHANGE_LICENSE_PLATE: 'Đổi biển số phương tiện',
    EXTEND_SERVICE: 'Gia hạn dịch vụ'
  };

  const renderMenu = (role, device) => {
    const menuActions = {
      ACTIVATE: () => handleActiveDevice(),
      SELECT_PACKAGE: () => handleEditDevice(),
      EDIT_DEVICE: () => handleEditVersion(),
      TRANSFER_AGENT: () => handleTransferDevice(device.id),
      EXTEND: () => handleExtendDevice(),
      RECALL: () => handleRecallDevice(),
      SELECT_SELLER: () => handleTransferSeller(),
      ADD_DISPLAY_NAME: () => handleAddDisplayName(),
      SWAP_LICENSE_PLATE: () => handleSwapLicensePlate(),
      CONTROL_ALERT: () => handleSettingSoundWarn(),
      DELETE: () => handleDeleteDevice(device.id),
      CHANGE_LICENSE_PLATE: () => handleChangeLicensePlate(),
      EXTEND_SERVICE: () => handleExtendService()
    };

    const getFilteredActions = (role, device) => {
      // Get define the base actions based on the role
      const baseActions = menuPermissions[role] || [];
      let status = device.status;

      const isExistPackage =
        device?.deviceServicePackages?.length !== 0 ? true : false;
      const isOutDate =
        status === 'active' &&
        device &&
        device?.deviceServicePackages?.remaining_days < 1;
      if (isExistPackage && status === 'inactive') {
        status = 'inactive_has_package';
      }

      if (isOutDate) {
        status = 'out_date';
      }

      const excludedByStatus = {
        active: ['ACTIVATE', 'TRANSFER_AGENT', 'SELECT_SELLER', 'DELETE'],
        inactive: [
          'EXTEND',
          'RECALL',
          'SELECT_PACKAGE',
          'ADD_DISPLAY_NAME',
          'SWAP_LICENSE_PLATE',
          'CONTROL_ALERT',
          'CHANGE_LICENSE_PLATE',
          'EXTEND_SERVICE',
        ],
        inactive_has_package: [
          'RECALL',
          'ADD_DISPLAY_NAME',
          'SWAP_LICENSE_PLATE',
          'CHANGE_LICENSE_PLATE',
          'EXTEND_SERVICE',
        ],
        out_date: [
          'ACTIVATE',
          'TRANSFER_AGENT',
          'SELECT_SELLER',
          'DELETE',
          'EDIT_DEVICE',
          'CONTROL_ALERT',
          'CHANGE_LICENSE_PLATE',
          'EXTEND_SERVICE',
        ]
      };

      const isUsingDisplayName = Boolean(device?.is_display_name);
      const excluded = excludedByStatus[status] || [];

      return baseActions.filter(action => {
        if (isUsingDisplayName && action === 'ADD_DISPLAY_NAME') {
          return false;
        }

        if (!isUsingDisplayName && action === 'SWAP_LICENSE_PLATE') {
          return false;
        }

        if (
          action === 'CONTROL_ALERT' &&
          device?.deviceType?.name !== 'VGPS_CAR4G'
        ) {
          return false;
        }

        return !excluded.includes(action);
      });
    };

    const allowedActions = getFilteredActions(role, device);

    return (
      <Box
        style={{
          borderRadius: '6px',
          backgroundColor: '#f8fafc',
          border: '1px solid rgba(0,0,0,0.12)',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
          overflow: 'hidden'
        }}
      >
        <List disablePadding>
          {allowedActions.map((item, index) => {
            const onClickHandler = menuActions[item];
            const isLastItem = index === allowedActions.length - 1;
            if (!onClickHandler) return null;

            return (
              <ListItem
                key={index}
                onClick={onClickHandler}
                className={classes.listItem}
                style={{
                  borderBottom: isLastItem
                    ? 'none'
                    : '1px solid rgba(0,0,0,0.1)',
                  cursor: 'pointer',
                  fontSize: '14px',
                  padding: '10px 16px'
                }}
              >
                {ACTION_LABELS[item]}
              </ListItem>
            );
          })}
        </List>
      </Box>
    );
  };

  // Menu action header bar
  const renderButtons = (role, row) => {
    const checkActive = row.status === 'active' ? true : false;
    const isInActive = row.status === 'inactive' ? true : false;
    const isActive =
      checkActive && row && row?.deviceServicePackages?.remaining_days > 0;
    const isExistPackage =
      row?.deviceServicePackages?.length !== 0 ? true : false;

    let buttonConfig = [
      // {
      //   id: 1,
      //   label: 'Chọn gói cước',
      //   onClick: () => setOpenEditModal(true),
      //   icon: '/static/iconSvg/dollar.svg',
      //   alt: 'seller'
      // },
      {
        id: 7,
        label: 'Chọn gói dịch vụ gia hạn',
        onClick: () => setOpenEditModal(true),
        icon: '/static/iconSvg/dollar.svg',
        alt: 'select service package'
      },
      {
        id: 2,
        label: 'Chọn người bán',
        onClick: () => setOpenModalSeller(true),
        icon: '/static/iconSvg/select-seller.svg',
        alt: 'seller'
      },
      {
        id: 3,
        label: 'Kích hoạt',
        onClick: () => setOpenModalActive(true),
        icon: '/static/iconSvg/car.svg',
        alt: 'seller'
      },
      {
        id: 4,
        label: 'Thu hồi',
        onClick: () => setOpenRecallModal(true),
        icon: '/static/iconSvg/recall.svg',
        alt: 'seller'
      },
      {
        id: 5,
        label: 'Chuyển xuống đại lý',
        onClick: () => setOpenTransferModal(true),
        icon: '/static/iconSvg/transfer.svg',
        alt: 'seller'
      },
      {
        id: 6,
        label: 'Xóa',
        onClick: () => handleDeleteMultiDevices(),
        icon: '/static/iconSvg/delete-icon.svg',
        alt: 'delete'
      }
    ];

    if (isInActive && isExistPackage) {
      buttonConfig = buttonConfig.filter(btn => ![2, 4].includes(btn.id));
    } else if (isInActive) {
      buttonConfig = buttonConfig.filter(btn => ![2, 4, 7].includes(btn.id));
    } else if (isActive) {
      buttonConfig = buttonConfig.filter(
        btn => ![1, 2, 3, 5, 6].includes(btn.id)
      );
    } else {
      buttonConfig = buttonConfig.filter(
        btn => ![1, 2, 3, 5, 6].includes(btn.id)
      );
    }

    const allowedButtons = buttonPermissions[role] || [];
    const filteredButtons = buttonConfig.filter(btn =>
      allowedButtons.includes(btn.label)
    );

    return (
      <>
        {filteredButtons.map((btn, index) => (
          <span
            key={index}
            onClick={btn.onClick}
            className="mx-2 btnDevice"
            color="primary"
            variant="outlined"
            size="small"
          >
            <img
              src={btn.icon}
              alt={btn.alt}
              style={{ paddingRight: '5px', paddingBottom: '4px' }}
            />
            <span className="pt-1">{btn.label}</span>
          </span>
        ))}
      </>
    );
  };

  const DeviceMenu = ({ role, device }) => {
    return renderMenu(role, device);
  };

  const DeviceButtons = ({ role, row }) => {
    return renderButtons(role, row);
  };

  const dataLogin = useSelector(state => state.authSlice.dataLogin);
  const role = dataLogin?.role?.title;
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isAgency = useSelector(state => state.authSlice.isAgency);
  const agencyId = useSelector(state => state.authSlice.agencyId);

  const [params, setParams] = useState({
    ...currentParams,
    page: currentParams?.page || page,
    page_size: currentParams?.page_size || limit
  });

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setPage(Number(pageFromQuery));
    }
    if (pageSizeFromQuery) {
      setLimit(Number(pageSizeFromQuery));
    }
  }, [query]);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const dataSelected = editOnBar ? dataChecked : itemCurrent;

  const checked = id => {
    return rowsSelected.indexOf(id) !== -1;
  };

  const select = (deviceId, device) => {
    let rowIndex = rowsSelected.indexOf(deviceId);
    setEditOnBar(true);
    setDataChecked(device);
    if (rowIndex === -1) {
      const newSelected = [deviceId, ...rowsSelected];
      setRowsSelected(newSelected);
    } else {
      const newSelected = rowsSelected.filter(i => i !== deviceId);
      setRowsSelected(newSelected);
    }
  };

  const handleDeleteMultiDevices = () => {
    dispatch(showDialogConfirm());
  };

  const confirmDeleteDevices = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id];
    dispatch(closeDialogConfirm());
    dispatch(deleteDevices({ list_device_ids: listId }));
    setRowsSelected([]);
  };

  const handleDeleteDevice = () => {
    dispatch(showDialogConfirm());
    handleCloseMenu();
  };

  const handleRecallDevice = () => {
    setOpenRecallModal(true);
    handleCloseMenu();
  };

  const handleExtendDevice = () => {
    setOpenExtendModal(true);
    handleCloseMenu();
  };

  const handleSettingSoundWarn = () => {
    setOpenModalSettingSound(true);
    handleCloseMenu();
  };

  const handleChangeLicensePlate = () => {
    setOpenChangeLicensePlateModal(true);
    handleCloseMenu();
  };

  const handleExtendService = () => {
    setOpenExtendServiceModal(true);
    handleCloseMenu();
  };

  const confirmSettingSoundWarn = () => {
    const deviceId = itemCurrent.id;
    const controlSoundReq = itemCurrent?.is_turn_on_sound ? 1 : 0;
    dispatch(
      controlSoundWarning({ id: deviceId, data: { status: controlSoundReq } })
    );
    dispatch(closeDialogConfirm());
    setOpenModalSettingSound(false);
    setRowsSelected([]);
  };

  const confirmExtendDevices = () => {
    const deviceId = itemCurrent.id;
    dispatch(closeDialogConfirm());
    dispatch(postExtendDevice({ id: deviceId, data: {} }));
    setOpenExtendModal(false);
    setRowsSelected([]);
  };

  const handleAddDisplayName = () => {
    setOpenDisplayNameModal(true);
    handleCloseMenu();
  };

  const handleSwapLicensePlate = () => {
    setOpenSwapLicensePlateModal(true);
    handleCloseMenu();
  };

  const handleTransferSeller = () => {
    setOpenModalSeller(true);
    handleCloseMenu();
  };

  const getStatusDevice = (status, remainingDays) => {
    switch (status) {
      case DEVICE_STATUS.ACTIVE:
        return (
          <span
            className="badge-actived badge"
            style={{
              backgroundColor: remainingDays > 0 ? '#d4efdf' : '#F8D7DA',
              color: remainingDays > 0 ? '#3DB670' : '#D9534F'
            }}
          >
            {remainingDays > 0 ? 'Kích hoạt' : 'Hết hạn'}
          </span>
        );
      case DEVICE_STATUS.INACTIVE:
        return (
          <span
            className="badge-inActived badge"
            style={{
              backgroundColor: '#E7E8EE',
              color: '#475461'
            }}
          >
            Lưu kho
          </span>
        );
      default:
        return '-';
    }
  };

  const getSlotsOrTonnage = (vehicleType, device) => {
    switch (vehicleType) {
      case 'Xe khách':
        return <span> {device.vehicle?.vehicle_type?.slots} chỗ </span>;
      case 'Xe tải':
        return <span> {device.vehicle?.vehicle_type?.tonnage}</span>;
      default:
        return '--';
    }
  };

  const confirmRecall = () => {
    const listId = rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id];
    if (isAdmin) {
      dispatch(recallDevices({ list_device_id: listId }));
    } else if (isAgency) {
      dispatch(
        recallDevicesByAgency({
          id: agencyId,
          data: { list_device_id: listId }
        })
      );
    }
    setRowsSelected([]);
    setOpenRecallModal(false);
  };

  const confirmSwap = async () => {
    await dispatch(
      updateDeviceDisplayName({
        id: itemCurrent.id,
        data: {
          enable: false
        }
      })
    );
    setOpenSwapLicensePlateModal(false);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListDeviceRef) return;
    const newparams = {
      ...currentParams,
      page: newPage,
      page_size: isMobile ? 6 : limit
    };
    setParams(newparams);
    getListDeviceRef(newparams);
  };

  const handleRequestSort = property => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedDevices = useMemo(() => {
    if (!Array.isArray(listDevice)) return [];

    return [...listDevice].sort((leftDevice, rightDevice) => {
      const leftValue = getDeviceSortValue(leftDevice, orderBy);
      const rightValue = getDeviceSortValue(rightDevice, orderBy);
      const comparison = compareSortValues(leftValue, rightValue);

      return order === 'asc' ? comparison : -comparison;
    });
  }, [listDevice, order, orderBy]);

  const handleGetDetailVehicle = deviceId => {
    dispatch(getDetailVehicle({ id: deviceId }));
  }

  const handleClickMenu = (event, device) => {

    if (device && device?.id) {
      handleGetDetailVehicle(device.id);
    }
    setAnchorEl(event.currentTarget);
    setItemCurrent(device);
    setEditOnBar(false);
  };

  const closeModalEdit = () => {
    setOpenEditModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalEditVersion = () => {
    setOpenEditVersionModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalTransfer = () => {
    setOpenTransferModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalTransferSeller = () => {
    setOpenModalSeller(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalActive = () => {
    setOpenModalActive(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalExtend = () => {
    setOpenExtendModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const closeModalExtendService = () => {
    setOpenExtendServiceModal(false);
    setRowsSelected([]);
    setItemCurrent({});
  };

  const handleCloseConfirm = () => {
    setRowsSelected([]);
    setItemCurrent({});
    return dispatch(closeDialogConfirm());
  };
  const checkAll = () => {
    if (rowsSelected.length > 0) {
      setRowsSelected([]);
    }
    if (listDevice?.length > 0 && rowsSelected.length !== listDevice?.length) {
      const all = listDevice.map(item => {
        return item.id;
      });
      setRowsSelected(all);
    }
  };

  const handleEditDevice = () => {
    setOpenEditModal(true);
    handleCloseMenu();
  };

  const handleEditVersion = () => {
    setOpenEditVersionModal(true);
    handleCloseMenu();
  };

  const handleTransferDevice = id => {
    setOpenTransferModal(true);
    handleCloseMenu();
  };

  const handleActiveDevice = () => {
    setOpenModalActive(true);
    handleCloseMenu();
  };

  const contentExtend = itemCurrent?.servicePackageExtend?.[0]?.servicePackage
    ?.name
    ? `Bạn có chắc chắn muốn gia hạn gói dịch vụ ${itemCurrent.servicePackageExtend?.[0]?.servicePackage?.name} không ?`
    : 'Vui lòng chọn gói dịch vụ để gia hạn';

  const titleControlSound = itemCurrent?.is_turn_on_sound
    ? 'Tắt âm thanh cảnh báo'
    : 'Bật âm thanh cảnh báo';

  const contentControlSound = itemCurrent?.is_turn_on_sound
    ? `Bạn có chắc chắn muốn tắt âm thanh cảnh báo không ?`
    : `Bạn có chắc chắn muốn bật âm thanh cảnh báo không ?`;

  return (
    <>
      <ModalConfirm
        title={`Thu hồi thiết bị`}
        content={`Bạn có chắn chắn muốn thu hồi thiết bị không ?`}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openRecallModal}
        setOpen={setOpenRecallModal}
        callbackOk={confirmRecall}
      />

      <ModalConfirm
        title={`Gia hạn gói dịch vụ`}
        content={contentExtend}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openExtendModal}
        setOpen={setOpenExtendModal}
        callbackOk={confirmExtendDevices}
      />

      <ModalConfirm
        title={titleControlSound}
        content={contentControlSound}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openModalSettingSound}
        setOpen={setOpenModalSettingSound}
        callbackOk={confirmSettingSoundWarn}
      />

      <ModalConfirm
        title={`Dùng Tên/Biển số`}
        content={`Bạn có chắn chắn muốn dùng Tên/biển số không ?`}
        textOk={'Đồng ý'}
        textCancel={'Hủy'}
        open={openSwapLicensePlateModal}
        setOpen={setOpenSwapLicensePlateModal}
        callbackOk={confirmSwap}
      />

      {/* {openExtendModal && (
        <ExtendDevice
          onClose={closeModalExtend}
          open={openExtendModal}
          device={dataSelected}
        />
      )} */}

      {openExtendServiceModal && (
        <ExtendService
          open={openExtendServiceModal}
          device={dataSelected}
          onClose={closeModalExtendService}
        />
      )}

      {openEditModal && (
        <EditDevice
          open={openEditModal}
          device={dataSelected}
          onClose={closeModalEdit}
        />
      )}

      {openEditVersionModal && (
        <EditVersion
          open={openEditVersionModal}
          device={dataSelected}
          onClose={closeModalEditVersion}
          fetchDetail={handleGetDetailVehicle}
        />
      )}

      {openModalActive && (
        <ActiveDevice
          open={openModalActive}
          onClose={closeModalActive}
          dataSelected={dataSelected}
        />
      )}

      {openTransferModal && (
        <TransferDevice
          open={openTransferModal}
          rowsSelected={
            rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id]
          }
          onClose={closeModalTransfer}
        />
      )}

      {openModalSeller && (
        <TransferSeller
          open={openModalSeller}
          rowsSelected={
            rowsSelected.length > 0 ? rowsSelected : [itemCurrent.id]
          }
          onClose={closeModalTransferSeller}
        />
      )}

      {openDisplayNameModal && (
        <AddDisplayName
          open={openDisplayNameModal}
          device={itemCurrent}
          onClose={() => setOpenDisplayNameModal(false)}
          onSuccess={() => getListDeviceRef(params)}
        />
      )}

      {openChangeLicensePlateModal && (
        <ChangeLicensePlate
          open={openChangeLicensePlateModal}
          device={itemCurrent}
          onClose={() => setOpenChangeLicensePlateModal(false)}
          onSuccess={() => getListDeviceRef(params)}
        />
      )}

      <DialogConfirm
        title={MESSAGE.CONFIRM_DELETE_DEVICE}
        textOk={MESSAGE.BTN_YES}
        textCancel={MESSAGE.BTN_CANCEL}
        content={MESSAGE.CONTENT_DELETE_DEVICE}
        callbackOk={() => confirmDeleteDevices()}
        callbackCancel={handleCloseConfirm}
      />

      <TableContainer
        component={Paper}
        style={{ maxWidth: '100%', overflowX: 'auto' }}
        className={classes.root}
      >
        <Box style={{ overflowX: 'auto' }} minWidth={1050}>
          {rowsSelected.length > 0 && (
            <Fade in={rowsSelected.length > 0}>
              <Box
                minWidth={1250}
                style={{ fontSize: '14px', padding: '9px 4px' }}
              >
                <span width={50}>
                  <Checkbox
                    checked={rowsSelected.length > 0}
                    onChange={() => checkAll()}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                  />
                </span>

                <DeviceButtons role={role} row={dataSelected} />
              </Box>
            </Fade>
          )}

          {/* <PerfectScrollbar> */}
          <Box mb={0} className={classes.tableWrapper}>
            <Table>
              {rowsSelected.length === 0 && listDevice?.length > 0 && (
                <TableHead>
                  <TableRow>
                    <TableCell width={50}>
                      <Checkbox
                        checked={rowsSelected.length > 0}
                        onChange={() => checkAll()}
                        color="primary"
                        inputProps={{
                          'aria-label': 'secondary checkbox'
                        }}
                      />
                    </TableCell>
                    <TableCell
                      style={{ width: 50, minWidth: 50, textAlign: 'center' }}
                    >
                      STT
                    </TableCell>
                    {DEVICE_TABLE_HEAD_CELLS.filter(
                      column => column.id !== 'index'
                    ).map(column => (
                      <TableCell
                        key={column.id}
                        sortDirection={orderBy === column.id ? order : false}
                        style={column.style}
                      >
                        {column.sortable === false ? (
                          column.label
                        ) : (
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : 'asc'}
                            onClick={() => handleRequestSort(column.id)}
                          >
                            {column.label}
                          </TableSortLabel>
                        )}
                      </TableCell>
                    ))}
                    <TableCell style={{ width: 50, minWidth: 50 }}></TableCell>
                  </TableRow>
                </TableHead>
              )}

              <TableBody>
                {sortedDevices.length > 0 ? (
                  sortedDevices.map((device, index) => (
                    <TableRow hover key={device.id}>
                      <TableCell>
                        <Checkbox
                          checked={checked(device.id)}
                          onChange={() => select(device.id, device)}
                          color="primary"
                          inputProps={{
                            'aria-label': 'secondary checkbox'
                          }}
                        />
                      </TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        {(params.page - 1) * params.page_size + index + 1}
                      </TableCell>
                      <TableCell>
                        {device?.vehicle?.license_plate || '--'}
                      </TableCell>
                      <TableCell>{device?.name || '--'}</TableCell>
                      <TableCell>
                        {device.vehicle?.vehicle_type?.title || '--'}
                      </TableCell>
                      <TableCell>
                        {device.battery || '--'}
                      </TableCell>
                      <TableCell>
                        {getSlotsOrTonnage(
                          device.vehicle?.vehicle_type?.title,
                          device
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        {device?.deviceType?.name === 'VGPS_CAR4G'
                          ? getTransmissionStatusText(device?.status_transmission)
                          : '--'}
                      </TableCell>
                      <TableCell>{device?.deviceType?.name || '--'}</TableCell>
                      <TableCell>{device.serial || '--'}</TableCell>
                      <TableCell>{device.imei || '--'}</TableCell>
                      <TableCell>{device?.hardware_version || '--'}</TableCell>
                      <TableCell>{device?.firmware_version || '--'}</TableCell>

                      <TableCell>
                        {getStatusDevice(
                          device?.status,
                          device?.deviceServicePackages?.remaining_days
                        )}
                      </TableCell>

                      <TableCell>
                        {device.active_at
                          ? moment(device.active_at).format(
                            'HH:mm:ss DD-MM-yyyy'
                          )
                          : '--'}
                      </TableCell>
                      <TableCell>
                        {device.deviceServicePackages?.servicePackage?.name ||
                          '--'}
                      </TableCell>
                      <TableCell>
                        {getRemainingDays(device?.subscription?.end) ||
                          '--'}
                      </TableCell>
                      <TableCell>
                        <RenderListExtendPackages
                          listPackages={device?.servicePackageExtend}
                          classes={classes}
                        />
                      </TableCell>
                      <TableCell>
                        {device?.date_of_manufacture
                          ? moment(device.date_of_manufacture).format(
                            'DD-MM-yyyy'
                          )
                          : '-'}
                      </TableCell>
                      <TableCell>
                        {device.end_user?.user?.full_name || '--'}
                      </TableCell>
                      <TableCell>
                        {device.end_user?.user?.phone || '--'}
                      </TableCell>

                      <TableCell>
                        <Tooltip title={device.agency?.name || '--'}>
                          <span>
                            {truncateText(device.agency?.name || '--', 30)}
                          </span>
                        </Tooltip>{' '}
                        {device.agency?.agency_code && (
                          <Tooltip title={`(${device.agency.agency_code})`}>
                            <span>
                              {truncateText(
                                `(${device.agency.agency_code})`,
                                15
                              )}
                            </span>
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>
                        <span style={{ color: '#AEB1C5' }}>
                          <MoreVertIcon
                            aria-describedby={`menu-device-${device.id}`}
                            className={`cursor-pointer hover-red`}
                            onClick={e => handleClickMenu(e, device)}
                          />
                        </span>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <Box
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100vw'
                    }}
                  >
                    <Box>
                      <img
                        src="/static/empty.png"
                        class="justify-content-center"
                      />
                    </Box>
                    <Typography>
                      <h4>Danh sách trống </h4>
                    </Typography>
                  </Box>
                )}
              </TableBody>
            </Table>

            <Popover
              id={`menu-device-${itemCurrent.id}`}
              className="popover-device"
              open={open}
              anchorEl={anchorEl}
              onClose={handleCloseMenu}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <DeviceMenu role={role} device={itemCurrent} />
            </Popover>
          </Box>
          {/* </PerfectScrollbar> */}
        </Box>
        {/* </Card> */}
      </TableContainer>
      {listDevice && listDevice.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalDevice}
            </Typography>
            <Pagination
              count={Math.ceil(totalDevice / limit)}
              color="primary"
              size="small"
              onChange={handlePageChange}
              page={Number(params.page) || 1}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 1 : 2}
              showFirstButton={!isMobile}
              showLastButton={!isMobile}
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listDevice: PropTypes.array.isRequired,
  currentParams: PropTypes.object
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  listItem: {
    cursor: 'pointer',
    borderBottom: '1px solid #e0e0e0',
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    },
    '&:last-child': {
      borderBottom: 'none'
    }
  },
  popover: {
    pointerEvents: 'none'
  },
  paper: {
    padding: theme.spacing(1)
  },
  tableWrapper: {
    '& .MuiTableCell-root': {
      borderBottom: '2px solid #F1F1F1 !important',
      padding: '4px !important'
    },
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#d2d9ddff',
      borderRadius: '8px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#bfc6caff'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '8px'
    }
  }
}));

export default React.memo(Results);
